import { ButtonBase } from '@mui/material';
import classNames from 'classnames';
import React from 'react';
import LangEnum from '../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../translation/TranslationContext';
import useOrderProductGridButtonStyles from '../../grid/components/orderProductGrid/components/buttons/styles/useOrderProductGridButtonStyles';

const ButtonOnNoUnableToPaste = () => {
  const { classes } = useOrderProductGridButtonStyles();
  const { translate } = useTranslation();

  return (
    <ButtonBase
      title={translate(LangEnum.ORDER_PRODUCTS_GRID_STATUS_INCOMPATIBLE)}
      disableRipple
      disabled
      tabIndex={-1}
      className={classNames(classes.button, classes.invalidPasteButton)}
    >
      {translate(LangEnum.GLOBAL_INVALID)}
    </ButtonBase>
  );
};

export default React.memo(ButtonOnNoUnableToPaste);
